import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'capsule',
  templateUrl: './capsule.component.html',
  styleUrls: ['./capsule.component.scss']
})
export class CapsuleComponent implements OnInit {
  @Input() label: string | undefined;
  @Input() backgroundColor = 'var(--surface-400)';
  @Input() swatchColor: string | undefined;
  @Input() small: boolean | undefined;
  @Input() inline: boolean = false;
  @Input() isDryRun: boolean | undefined;

  constructor() { }

  ngOnInit(): void {
  }

}
